import { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { GlobalContext } from "../../context/globalContext";
import {
  httpAPI_COM005,
  httpAPI_COM009,
  httpAPI_RET015,
  httpAPI_RET016,
} from "./api/request";
import { IAPI_RET015_Response } from "../../type/apiType";
import TkButton from "../../components/atoms/TkButton";
import { Box, Link } from "@mui/material";
import "./_style.scss";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import { BusinessContext } from "../../context/businessContext";
import { FormClassApply, FormKbn } from "../../assets/data/Constants";
import TkDownloadLink from "../../components/atoms/TkDownloadLink";
import { explanatoryText } from "./parts";

/**
 * SCRR411102 退職手当金の請求手続き又は合算制度利用手続き
 * @Todo ポーリング処理
 * @return SCRR411102 退職手当金の請求手続き又は合算制度利用手続き
 */
const SCRR411102 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);

  const [retirementRequestButton, setRetirementRequestButton] =
    useState<boolean>(false);
  const [retirementBillDownloadButton, setRetirementBillDownloadButton] =
    useState<boolean>(true);
  const [retirementRequestflowConfirm, setRetirementRequestflowConfirm] =
    useState<boolean>(true);
  const [aggregationButton, setAggregationButton] = useState<boolean>(false);

  const [retirementRequestMessage, setRetirementRequestMessage] =
    useState<string>("");
  const [openRetirementRequestDialog, setOpenRetirementRequestDialog] =
    useState<boolean>(false);
  const [openTotalingUseDialog, setOpenTotalingUseDialog] =
    useState<boolean>(false);

  const [resData, setResData] = useState<IAPI_RET015_Response>({
    resultCd: "",
  });

  const [stopApiRequest, setStopApiRequest] = useState<boolean>(false);
  const [retirementFile, setRetirementFile] = useState<{
    fileName: string;
    fileBase64: string;
  }>({
    fileName: "",
    fileBase64: "",
  });
  const timerId = useRef<NodeJS.Timeout | null>(null);
  const staffNo =
    location.state?.staffNo ??
    businessState.job_35?.staffNo ??
    businessState.job_36?.staffNo ??
    businessState.job_32?.staffNo;
  const staffName =
    location.state?.staffName ?? businessState.job_35?.staffName;

  const handleInit = async () => {
    try {
      // 退職手当金の請求手続き又は合算制度利用手続き確認表示API実行
      const res = await httpAPI_RET015({
        contractorNo:
          state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO
            ? businessState.common?.contractorNo
            : state.authInfo?.contractorNo,
        staffNo: staffNo,
      });

      if (res.resultCd === "I0000") {
        handleDownloadData(res.retirementFormApplyId);
        setResData(res);
        if (
          res.maePeriodYear !== undefined &&
          res.maePeriodYear < 1 &&
          res.enrollYear !== undefined &&
          1 <= res.enrollYear
        ) {
          setRetirementRequestButton(true);
        }

        if (
          res.businessType === "JOB-35" &&
          !(
            res.statusCd === "00" ||
            res.statusCd === "15" ||
            res.statusCd === "16"
          )
        ) {
          setRetirementRequestflowConfirm(false);
        }

        if (
          res.businessType === "JOB-36" &&
          !(
            res.statusCd === "00" ||
            res.statusCd === "15" ||
            res.statusCd === "16"
          )
        ) {
          setAggregationButton(true);
        }

        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  // 初期表示
  useEffect(() => {
    handleInit();
    return () => {
      if (timerId.current) {
        clearTimeout(timerId.current);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleDownloadData = async (applyId: any) => {
    try {
      // 帳票作成状況取得APIを呼び出す。
      const res = await httpAPI_COM009({
        applyId: applyId,
        FormList: [
          {
            formClass: FormClassApply["退職手当金請求書"],
            formKbn: FormKbn["申請"],
          },
        ],
      });

      if (res.resultCd === "I0000") {
        let requestId = "";
        res.FormList?.forEach((form) => {
          if (form.formOutputStatus === "3") {
            requestId = form.requestId!;
            handleDownload(requestId);
            setRetirementBillDownloadButton(false);
          }
        });

        if (requestId) {
          setStopApiRequest(true);
          clearTimeout(timerId.current!);
        } else {
          if (!stopApiRequest) {
            timerId.current = setTimeout(() => {
              handleDownloadData(applyId);
            }, 10000);
          }
        }
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const handleDownload = async (requestId: string) => {
    // 帳票ダウンロード(汎用)APIを呼び出す
    try {
      const res = await httpAPI_COM005({
        formList: [{ requestId: requestId }],
      });

      if (res.resultCd === "I0000") {
        setRetirementFile({
          fileName: res.formList?.[0].fileName || "",
          fileBase64: res.formList?.[0].fileBase64 || "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const clickRetirementRequestButton = () => {
    if (
      resData.businessType === "JOB-36" &&
      !(
        resData.statusCd === "00" ||
        resData.statusCd === "15" ||
        resData.statusCd === "16"
      )
    ) {
      setRetirementRequestMessage(
        "　合算制度の利用をやめて、退職手当金請求に切り替えます。よろしいですか？"
      );
      setOpenRetirementRequestDialog(true);
    } else if (resData.businessType === "JOB-36" && !!resData.applyId) {
      setRetirementRequestMessage(
        "　合算制度の利用について途中まで入力中です。入力済のデータを削除し、退職手当金の請求にきりかえますか？"
      );
      setOpenRetirementRequestDialog(true);
    } else {
      setBusinessState({
        ...businessState,
        common: { ...businessState.common, businessType: "JOB-35" },
        job_35: {
          ...businessState.job_35,
          staffNo,
          applyId: resData.applyId,
        },
      });

      navigate("/SCRR410003", { state: { email: state.authInfo?.email } });
    }
  };

  const okRetirementRequest = async () => {
    try {
      // 退職手当金請求、合算制度利用不要データ削除APIを呼び出す。
      const res = await httpAPI_RET016({
        applyId: resData.applyId,
        businessType: resData.businessType,
        retirementFormApplyId: resData.retirementFormApplyId,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        setBusinessState({
          ...businessState,
          common: { ...businessState.common, businessType: "JOB-35" },
          job_35: {
            ...businessState.job_35,
            staffNo,
          },
        });

        navigate("/SCRR410003");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const closeRetirementRequest = () => {
    setOpenRetirementRequestDialog(false);
  };

  const clickTotalingUse = () => {
    if (resData.businessType === "JOB-35" && !!resData.applyId) {
      setOpenTotalingUseDialog(true);
    } else {
      setBusinessState({
        ...businessState,
        common: { ...businessState.common, businessType: "JOB-36" },
        job_36: {
          ...businessState.job_36,
          staffNo,
          applyId: resData.applyId,
        },
      });

      navigate("/SCRR410004");
    }
  };

  const okTotalingUse = async () => {
    try {
      // 退職手当金請求、合算制度利用不要データ削除APIを呼び出す
      const res = await httpAPI_RET016({
        applyId: resData.applyId,
        businessType: resData.businessType,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        setBusinessState({
          ...businessState,
          common: { ...businessState.common, businessType: "JOB-36" },
          job_36: {
            ...businessState.job_36,
            staffNo,
          },
        });

        navigate("/SCRR410004");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const closeTotalingUse = () => {
    setOpenTotalingUseDialog(false);
  };

  const clickRetirementRequestflowConfirm = () => {
    setBusinessState({
      ...businessState,
      common: { ...businessState.common, businessType: "JOB-35" },
    });

    navigate("/SCRR410030/", {
      state: { staffNo: staffNo, staffName: staffName },
    });
  };

  const totalingApply = () => {
    window.open("https://www.wam.go.jp/hp/wp-content/uploads/kyousai-y7-3.pdf");
  };

  return (
    <Box data-testid="SCRR411102PageForTest" className="tkSCRR411102">
      {explanatoryText}

      <Box className="tkLikeLink">
        <Link
          href="https://www.wam.go.jp/hp/guide-taisyokuteate-tabid-424/"
          target="_blank"
        >
          ・退職金シミュレーション
        </Link>
        <Link
          href="https://www.wam.go.jp/hp/guide-taisyokuteate-tabid-saikanyu/"
          target="_blank"
        >
          ・退職・再加入シミュレーション
        </Link>
      </Box>

      <Box className="tkDisplay">
        {!(
          resData?.businessType === "JOB-35" &&
          !(
            resData.statusCd === "00" ||
            resData.statusCd === "15" ||
            resData.statusCd === "16"
          )
        ) && (
          <>
            <TkButton
              onClick={clickRetirementRequestButton}
              disabled={retirementRequestButton}
            >
              {"退職手当金を請求"}
            </TkButton>
            <TkDownloadLink
              dataname={retirementFile.fileName}
              base64filedata={retirementFile.fileBase64}
              isButton={true}
              buttonName="退職金請求書をダウンロード"
              buttonDisabled={retirementBillDownloadButton}
              downloadBase64={true}
            />
            <TkButton disabled={aggregationButton} onClick={clickTotalingUse}>
              {"合算制度を利用"}
            </TkButton>
            <TkButton onClick={totalingApply}>{"合算申出書を表示"}</TkButton>
          </>
        )}

        <TkButton
          onClick={clickRetirementRequestflowConfirm}
          disabled={retirementRequestflowConfirm}
        >
          {"退職手当金の請求手続き確認"}
        </TkButton>
      </Box>

      <TkMessageDialog
        open={openRetirementRequestDialog}
        title="確認（退職手当金請求に切り替えます）"
        contextText={retirementRequestMessage}
        okText="はい"
        cancelText="いいえ"
        onOky={okRetirementRequest}
        onCancel={closeRetirementRequest}
      />

      <TkMessageDialog
        open={openTotalingUseDialog}
        title="確認（合算制度利用に切り替えます）"
        contextText="　退職手当金請求が途中まで入力中です。入力済のデータを削除し、合算制度の利用にきりかえますか？"
        okText="はい"
        cancelText="いいえ"
        onOky={okTotalingUse}
        onCancel={closeTotalingUse}
      />
    </Box>
  );
};

export default SCRR411102;
